import { Vehicle } from 'Models';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig';
import type { VehicleValue } from 'Models/vehicle';
import { loadSelectedVehicle } from 'Utils/userStorage';

import { default as getRequestFromUri } from './getRequestFromUri';

export default function getVehicleFromUri(): { isVehicleNew: boolean; selection: VehicleValue[] } {
  const fitmentFields = fitmentSearchConfig.fields;
  const selectionFromUri: VehicleValue[] = getRequestFromUri(window.location).selection.filter((v) =>
    fitmentFields.includes(v.field),
  );

  let isVehicleNew = false;

  if (selectionFromUri.length) {
    const vehicleFromUri = new Vehicle(selectionFromUri, fitmentFields);
    isVehicleNew = !loadSelectedVehicle().equals(vehicleFromUri);
  }

  return { isVehicleNew, selection: selectionFromUri };
}
